import React from "react";
import { getKpiReportV2 } from "../api/kpi";
import KpiReportContent from "../components/KpiReport/KpiReportContent";
import { KpiReportLoader } from "../components/KpiReport/KpiReportLoader";

// Hidden preview of the KPI report as it will look once published. Only Super
// Admins reach it (route rule and backend endpoint), so the final report can be
// reviewed on production before the backend flag is turned on for everyone.
const KpiReportV2: React.FC = () => (
  <KpiReportLoader load={getKpiReportV2}>
    {(v2) => (
      <>
        <p className="text-sm text-gray-500 mb-6">
          Preview of the KPI report after publishing — visible to Super Admins only.
          The client still sees the current report until it is published.
        </p>
        <KpiReportContent
          data={v2.report}
          csvFilePrefix="kpi-report-v2"
          activeUsersComparison={v2.activeUsersComparison}
        />
      </>
    )}
  </KpiReportLoader>
);

export default KpiReportV2;
